import { css } from 'styled-components';

export const resetCss = css`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body {
    overflow: hidden;
    height: 100%;
    width: 100%;
  }

  #root {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: rgba(11, 28, 48, 0.22) transparent;
  }
  ::-webkit-scrollbar {
    width: 0.5rem;
    height: 0.5rem;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(11, 28, 48, 0.22);
    border-radius: 1rem;
    border: 0.125rem solid transparent;
    background-clip: content-box;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 76, 76, 0.45);
  }

  img {
    display: block;
  }
`;
